import React, { useEffect, useState } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import config from "../config";

const DebugScene = () => {
  const [teamsContext, setTeamsContext] = useState<microsoftTeams.Context | null>(null);
  const [callChainId, setCallChainId] = useState<string | null>(null);

  useEffect(() => {
    microsoftTeams.initialize();
    microsoftTeams.getContext((context: microsoftTeams.Context) => {
      setTeamsContext(context);
      // If callChainId is expected to be a custom property, use type assertion or optional chaining
      const callChainId = (context as any)?.call?.callChainId;
      if (callChainId) {
        setCallChainId(callChainId);
      }
    });
  }, []);

  return (
    <div style={{ padding: 10, maxWidth: 320, wordWrap: "break-word" }}>
      <h1>Debug Information</h1>
      <h2>Config</h2>
      <pre style={{ background: "#f4f4f4", padding: 10, borderRadius: 5 }}>
        {JSON.stringify(config, null, 2)}
      </pre>
      <h2>Process Environment</h2>
      <pre style={{ background: "#f4f4f4", padding: 10, borderRadius: 5 }}>
        {JSON.stringify(process.env, null, 2)}
      </pre>
      <h2>Teams Context</h2>
      <pre style={{ background: "#f4f4f4", padding: 10, borderRadius: 5 }}>
        {JSON.stringify(teamsContext, null, 2)}
      </pre>
      {callChainId && (
        <div style={{ marginTop: 20 }}>
          <strong>Call Chain ID:</strong> {callChainId}
        </div>
      )}
    </div>
  );
};

export default DebugScene;
